import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import {
	Sidebar,
	Header,
	MainNav,
	Loader,
	AccessDenied,
	ErrorLoadingContent,
} from 'ui/components';
import { FORBIDDEN, PRIVACY_POLICY_LINK } from 'config/constants';
import { FormattedMessage } from 'ui/i18n';

import './Container.scss';

@inject('AppState')
@observer
export class Container extends Component {
	static propTypes = {
		children: PropTypes.array,
		AppState: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired,
	};

	static defaultProps = {
		children: [],
	};

	componentWillMount() {
		this.history.listen(({ pathname }) => this.AppState.saveLocation(pathname));
	}

	shouldComponentUpdate() {
		return true;
	}

	history = this.props.history;
	AppState = this.props.AppState;

	render() {
		const { children } = this.props;
		const { fetchUser, applicationLoading } = this.AppState;

		return (
			<div className="app Container">
				{applicationLoading
					? <Loader fullScreen={true} />
					: fetchUser.handle({
							rejected: error =>
								error.status === FORBIDDEN
									? <AccessDenied />
									: <div className="AccessDenied">
											<ErrorLoadingContent />
										</div>,
							resolved: () =>
								<div>
									<Header />
									<MainNav />

									<div className="container-app appContent">
										<div className="sidebar">
											<Sidebar />
										</div>
										<div className="mainContent">
											{React.Children.toArray(children)}

											<div className="footerLinksContainer">
												<a
													className="privacyPolicyLink"
													target="_blank"
													href={PRIVACY_POLICY_LINK}
												>
													<FormattedMessage id="general.privacyPolicy" />
												</a>
											</div>
										</div>
									</div>
								</div>,
						})}
			</div>
		);
	}
}

export default withRouter(Container);



// WEBPACK FOOTER //
// ./src/ui/components/Container/index.js